/**
 * Created by sange on 26/09/2017.
 */


const prefix = 'Jean | '

export const appTitles = {
  login: prefix + 'Login',
  logout: prefix + 'Logout',
  resetPwd: prefix + 'Reset password',
  renewPwd: prefix + 'Set new password',
  notFound: prefix + '404',
  conversations: prefix + 'Conversations',
  teams: prefix + 'Teams',
  rights: prefix + 'Rights',
  reports: prefix + 'Report',
  profile: prefix + 'My Profile',
}




// WEBPACK FOOTER //
// ./src/app/app-titles.ts